import {
  createInstance,
  Identify,
} from '@amplitude/marketing-analytics-browser';
import { Tracker, defaultPageViewPath, defaultPageViewTitle } from './tracker';

export class AmplitudeTracker implements Tracker {
  private eventConfig: { [key: string]: any } = {};
  private identityConfig: { [key: string]: any } = {};
  private amplitude = createInstance();

  constructor(private options: { apiKey: string; userId?: string }) {
    this.amplitude.init(this.options.apiKey, this.options.userId, {
      pageViewTracking: false,
    });
  }

  private internalTrack(params: { [key: string]: any }) {
    if (window.location.hostname !== 'localhost') {
      const { event, ...rest } = params;
      this.amplitude.track(event, rest);
    }
  }

  config({
    appName,
    appVersion,
    employerId,
    employerName,
    householdId,
    userId,
    ...params
  }: {
    [key: string]: any;
  }) {
    if (userId) {
      this.amplitude.setUserId(userId);
    }

    const identity = new Identify();

    if (appName) {
      identity.setOnce('appName', appName);
    }
    if (appVersion) {
      identity.setOnce('appVersion', appVersion);
    }
    if (householdId) {
      identity.setOnce('householdId', householdId);
    }
    if (employerId) {
      identity.setOnce('employerId', employerId);
      this.amplitude.setGroup('employerId', employerId);
    }
    if (employerName) {
      identity.setOnce('employerName', employerName);
    }

    this.amplitude.identify(identity);

    Object.assign(this.identityConfig, {
      userId,
      appName,
      appVersion,
      householdId,
      employerId,
      employerName,
    });
    Object.assign(this.eventConfig, params);
  }

  pageView(params: { path?: string; title?: string; [key: string]: any }) {
    this.internalTrack({
      ...this.eventConfig,
      event: 'page_view',
      path: params.path ?? defaultPageViewPath(),
      title: params.title ?? defaultPageViewTitle(),
      ...params,
    });
  }

  track({
    action,
    category,
    label,
    value,
    ...rest
  }: {
    action: string;
    category: string;
    label: string;
    value?: number;
    [key: string]: any;
  }) {
    this.internalTrack({
      ...this.eventConfig,
      event: 'event',
      category,
      action,
      label,
      value,
      ...rest,
    });
  }
}
